<base-site-layout
    [heading]="'Bestellen im Namen von' | translate"
    headerIcon="fas fa-user"
    [isDialog]="true"
    (dialogCloseClicked)="close()"
>
    <iim-card>
        <div class="px-3">
            @if (loading()) {
                <div class="d-flex align-items-center text-description py-2">
                    <em class="fas fa-spinner fa-spin me-2"></em>
                    {{ 'Mitarbeiter werden geladen' | translate }}
                </div>
            } @else if (loadFailed()) {
                <div class="alert alert-warning mb-0">
                    {{ 'Mitarbeiter konnten nicht geladen werden.' | translate }}
                </div>
            } @else {
                <p class="text-description">
                    {{
                        'Wählen Sie den Mitarbeiter aus, für den Sie diese Bestellung auslösen möchten.'
                            | translate
                    }}
                </p>
                <iim-advanced-autocomplete
                    [label]="'Zielbenutzer' | translate"
                    [placeholder]="'Mitarbeiter suchen' | translate"
                    (valueSelected)="onOptionSelected($event)"
                    dataCyPrefix="ORDER_ON_BEHALF_TARGET_USER_AUTOCOMPLETE"
                >
                    @for (option of candidates(); track option.valueDisplay) {
                        <iim-autocomplete-option [value]="option">{{ option.valueDisplay }}</iim-autocomplete-option>
                    }
                </iim-advanced-autocomplete>
            }
        </div>
    </iim-card>
    <div class="row justify-content-end mt-3">
        <div class="col-auto">
            <button class="btn btn-success" [disabled]="!selected()" (click)="save()">
                <em class="fas fa-check px-1"></em>
                {{ 'Übernehmen' | translate }}
            </button>
        </div>
    </div>
</base-site-layout>
